export const download = {
	content: {
		pl: 'Aby skorzystać z\xa0aplikacji Moje Zdrowie+ pobierz ją z\xa0App Store albo Google Store'
	}
};
